<template>
  <div :style="[basicStyle, customStyle]" >
  </div>
</template>

<script>
import { calcNum } from '../StyleSheet';

export default {
  name: 'hyDivider',
  props: {
    height: {
      type: Number,
      default: 1,
      isRequired: false,
    },
    color: {
      type: String,
      default: '#EEEEEE',
      isRequired: false,
    },
    customStyle: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    basicStyle: {
      get() {
        return {
          height: calcNum(this.height),
          backgroundColor: this.color,
          // flex: 1,
        };
      },
    },
  },
};
</script>
